export enum TimeListSort {
  WorkName = "Name",
  Contact = "Customer",
  WorkType = "WorkType",
  TotalTime = "Duration",
  Date = "Date",
  Total = "Total",
  Assignee = "AssignedUser",
  Status = "Status",
  Notes = "Notes",
  Type = "Type",
}

export enum TimeListTitle {
  WorkName = "Task Name",
  Contact = "Contact",
  WorkType = "Work Type",
  TotalTime = "Total Time",
  Date = "Date",
  Total = "Total",
  Assignee = "Assignee",
  Status = "Status",
  Notes = "Notes",
  Type = "Type",
}

export enum TimeColumnKey {
  WorkName = "workName",
  Contact = "contact",
  WorkType = "workType",
  TotalTime = "totalTime",
  Date = "date",
  Total = "total",
  Status = "status",
  Assignee = "assignee",
  Notes = "notes",
  Type = "type",
}

export const DEFAULT_VISIBLE_TIME_COLUMNS: TimeColumnKey[] = [
  TimeColumnKey.WorkName,
  TimeColumnKey.Contact,
  TimeColumnKey.WorkType,
  TimeColumnKey.TotalTime,
  TimeColumnKey.Date,
  TimeColumnKey.Total,
  TimeColumnKey.Status,
  TimeColumnKey.Assignee,
  TimeColumnKey.Notes,
  TimeColumnKey.Type,
];

export type TimeListHeaderItem = {
  title: TimeListTitle;
  sort: TimeListSort;
  column: TimeColumnKey;
  hideSort?: boolean;
};

const ALL_TIME_LIST_HEADER_ITEMS: TimeListHeaderItem[] = [
  {
    title: TimeListTitle.Date,
    sort: TimeListSort.Date,
    column: TimeColumnKey.Date,
  },
  {
    title: TimeListTitle.Type,
    sort: TimeListSort.Type,
    column: TimeColumnKey.Type,
  },
  {
    title: TimeListTitle.WorkName,
    sort: TimeListSort.WorkName,
    column: TimeColumnKey.WorkName,
  },
  {
    title: TimeListTitle.Contact,
    sort: TimeListSort.Contact,
    column: TimeColumnKey.Contact,
  },
  {
    title: TimeListTitle.WorkType,
    sort: TimeListSort.WorkType,
    column: TimeColumnKey.WorkType,
  },
  {
    title: TimeListTitle.TotalTime,
    sort: TimeListSort.TotalTime,
    column: TimeColumnKey.TotalTime,
  },
  {
    title: TimeListTitle.Total,
    sort: TimeListSort.Total,
    column: TimeColumnKey.Total,
  },
  {
    title: TimeListTitle.Status,
    sort: TimeListSort.Status,
    column: TimeColumnKey.Status,
    hideSort: true,
  },
  {
    title: TimeListTitle.Assignee,
    sort: TimeListSort.Assignee,
    column: TimeColumnKey.Assignee,
  },
  {
    title: TimeListTitle.Notes,
    sort: TimeListSort.Notes,
    column: TimeColumnKey.Notes,
    hideSort: true,
  },
];

export const getTimeListHeaderItems = ({
  visibleColumns = DEFAULT_VISIBLE_TIME_COLUMNS,
}: {
  visibleColumns?: TimeColumnKey[];
} = {}): TimeListHeaderItem[] =>
  ALL_TIME_LIST_HEADER_ITEMS.filter((item) =>
    visibleColumns.includes(item.column),
  );
